import ClickableLink from 'components/Common/Clickable/ClickableLink'
import ResponsiveImage from 'components/Common/ResponsiveImage'
import Heading from 'components/Luxkit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { getCustomerTypePanel } from 'lib/peopleLikeMeUtils'
import { rem } from 'polished'
import cn from 'clsx'
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-flow: wrap;
  &.centred {
    justify-content: center;
  }
  ${mediaQueryUp.sm} {
    align-content: space-between;
  }
`

const StyledHeading = styled(Heading)`
  position: absolute;
  size: ${rem(16)};
  bottom: 0;
  padding-bottom: ${rem(16)};
  padding-left: ${rem(16)};
`

const StyledClickableLink = styled(ClickableLink)`
  position: relative;
  max-width: 50%;
`

const StyledResponsiveImage = styled(ResponsiveImage)`
  padding-right: ${rem(16)};
  padding-top: ${rem(16)};
  max-width: ${rem(180)};
`

const imageAspectRatios = {
  xs: '7:10',
  sm: '7:10',
  md: '7:10',
  lg: '7:10',
}

interface Props {
  onClick: () => void
  isCentred?: boolean
}

function PeopleLikeMeSelectionPanels(props: Props) {
  const { onClick, isCentred = false } = props
  const panelImages = getCustomerTypePanel()
  return (
    <Container className={cn({ centred: isCentred })}>
      {panelImages.map((panel) =>
        <StyledClickableLink to={panel.path} onClick={onClick} key={panel.imageId}>
          <StyledResponsiveImage {...imageAspectRatios} mdWidth="180px" xsWidth="160px" id={panel.imageId} brightness={-10}/>
          <StyledHeading variant="heading5" colour="neutral-eight">
            {panel.label}
          </StyledHeading>
        </StyledClickableLink>,
      )}
    </Container>
  )
}

export default PeopleLikeMeSelectionPanels
